import { theme } from "./theme";
import { StrictMode } from "react";
import { routeTree } from "./routeTree.gen";
import { createRoot } from "react-dom/client";
import { NotFound } from "./components/notFound";
import { LicenseManager } from "ag-grid-enterprise";
import { AuthProvider, useAuth } from "./context/auth";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const routerContext = {
  useAuth
};
const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <NotFound />,
  context: routerContext,
  scrollRestoration: true
});

LicenseManager.setLicenseKey(
  "License_AG_Both[v3][0102]_MjA1NDY3ODQwMDAwMA==1b191d4780dd4a02a78bed89c8854741"
);

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const domNode = document.getElementById("root")!;
const root = createRoot(domNode);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <CssBaseline />
          <RouterProvider router={router} />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);

export { router };
